module.exports = __webpack_public_path__ + "img/onca-vega-isotipo-120.0ab01b7a.svg";